const PASSWORD_RESET_FRAGMENT_PREFIX = "#password-reset=";
const PASSWORD_RESET_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

let pendingPasswordResetToken: string | null = null;

interface ResetLinkLocation {
  hash: string;
  pathname: string;
  search: string;
}

interface ResetLinkHistory {
  state: unknown;
  replaceState(data: unknown, unused: string, url?: string | URL | null): void;
}

/** Captures an opaque reset capability in memory and removes it from browser history before React renders. */
export function capturePasswordResetLink(
  location: ResetLinkLocation = window.location,
  history: ResetLinkHistory = window.history,
): void {
  if (!location.hash.startsWith(PASSWORD_RESET_FRAGMENT_PREFIX)) return;

  const candidate = location.hash.slice(PASSWORD_RESET_FRAGMENT_PREFIX.length);
  history.replaceState(history.state, "", `${location.pathname}${location.search}`);
  pendingPasswordResetToken = PASSWORD_RESET_TOKEN_PATTERN.test(candidate) ? candidate : null;
}

export function hasPendingPasswordReset(): boolean {
  return pendingPasswordResetToken !== null;
}

/** Reads the in-memory reset capability without persisting it or exposing it to browser history. */
export function readPasswordResetToken(): string | null {
  return pendingPasswordResetToken;
}

export function clearPasswordResetToken(): void {
  pendingPasswordResetToken = null;
}
